import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import IntlComponent from 'axway-react-intl';
import browserHistory from 'components/utility/history';
import { Panel } from 'axway-react-ui';
import { Accordion, Glyphicon } from 'react-bootstrap';

export class FlowTriggerErrorsView extends React.Component {
	constructor(props) {
		super(props);
		IntlComponent.init(this);
	}

	navigateTo(ev, link) {
		ev.stopPropagation();
		ev.preventDefault();
		browserHistory.push(link);
	}

	addIssue(index, { trigger, flowId }) {
		const link = `${window.$conf.prefix}/project/flows/${encodeURIComponent(flowId)}/edit`;
		const editFlowText = this.intl.formatMsg('Edit Flow');
		const errorBadgeLabel = this.intl.formatMsg('ERROR');
		return (
			<div key={index} className="opblock opblock-delete">
				<div className="opblock-summary opblock-summary-delete default-cursor">
					<div className="operation-summary">
						<span className="opblock-summary-method">
							{errorBadgeLabel}
						</span>
						<span className="opblock-summary-path">
							<span>{trigger}</span>
						</span>
					</div>
					<div className="operation-actions">
						<a
							className="btn edit-flow"
							href={link}
							onClick={ev => this.navigateTo(ev, link)}
						>
							{editFlowText}
						</a>
					</div>
				</div>
				<noscript />
			</div>
		);
	}

	render() {
		const {
			invalidTriggers
		} = this.props;
		const panelText = <span><Glyphicon glyph=" gg icon-GG-warning red" /> {this.intl.formatMsg('Invalid operations')}</span>;
		return (
			<div className="flow-trigger-errors-view openapi oas-swagger-ui hide-scheme-container">
				<div className="swagger-ui">
					<div className="wrapper">
						<Accordion id="panel">
							<Panel
								eventKey="1"
								hasIcon
								header={panelText}
								independent
								defaultExpanded
							>
								<p className="invalid-triggers-warning">
									{this.intl.formatMsg('This API has issues that need to be addressed before going to production. The operations below all have issues that need to be addressed. These issues can be resolved by editing the flow and fixing them in that editor, or you can delete the flow if it is no longer in use.')}
								</p>
								{
									Object.keys(invalidTriggers).map((trigger, index) => {
										const { flowId, error } = invalidTriggers[trigger];
										return this.addIssue(
											index,
											{ trigger, flowId, error }
										);
									})
								}
							</Panel>
						</Accordion>
					</div>
				</div>
			</div>
		);
	}
}

FlowTriggerErrorsView.propTypes = {
	invalidTriggers: PropTypes.object.isRequired
};

export default injectIntl(FlowTriggerErrorsView);
